// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__S9EbY","sidebar--narrow":"Sidebar_sidebar--narrow__z86ny","sidebar__header-links":"Sidebar_sidebar__header-links__546AZ"};